import { transform as transformLineChart } from './line';
import { transform as transformTableChart } from './table';
import { transform as transformCircularChart } from './circular';
import { transform as transformHeatmapChart } from './heatmap';
import { transform as transformBarChart } from './bar';
import { transform as transformFunnelChart } from './funnel';
import { transform as transformMetricChart } from './metric';
import { transform as transformChoroplethChart } from './choropleth';
import { transform as transformGaugeChart } from './gauge';
export var transformData = function (_a) {
    var widgetType = _a.widgetType, chartSettings = _a.chartSettings, query = _a.query;
    switch (widgetType) {
        case 'choropleth':
            return transformChoroplethChart({
                chartSettings: chartSettings,
                query: query,
            });
        case 'metric':
            return transformMetricChart({
                chartSettings: chartSettings,
                query: query,
            });
        case 'funnel':
            return transformFunnelChart({
                chartSettings: chartSettings,
                query: query,
            });
        case 'bar':
            return transformBarChart({
                chartSettings: chartSettings,
                query: query,
            });
        case 'heatmap':
            return transformHeatmapChart({
                chartSettings: chartSettings,
                query: query,
            });
        case 'pie':
        case 'donut':
            return transformCircularChart({
                chartSettings: chartSettings,
                query: query,
            });
        case 'line':
        case 'area':
            return transformLineChart({
                chartSettings: chartSettings,
                query: query,
            });
        case 'table':
            return transformTableChart({
                chartSettings: chartSettings,
                query: query,
            });
        case 'gauge':
            return transformGaugeChart({
                chartSettings: chartSettings,
                query: query,
            });
        default:
            return [[], []];
    }
};
